<template>
  <div class="qr-code body-max-width">
    <Header menu="disable" title="Qr code"></Header>
    <div class="code-card">
      <div class="center">
        <img
          src="@/assets/image/logo.png"
          alt=""
          class="mx-auto"
          style="
            width: 100%;
            max-width: 19rem;
            height: 100%;
            object-fit: scale-down;
          "
        />
      </div>
      <div class="center">
        <!-- <img
          :src="qr_codeLink"
          alt=""
          class="mx-auto"
          style="
            width: 100%;
            max-width: 25rem;
            height: 100%;
            object-fit: scale-down;
          "
        /> -->

        <QRCodeVue3
          :width="250"
          :height="250"
          :value="orderId"
          :qrOptions="{
            typeNumber: 0,
            mode: 'Byte',
            errorCorrectionLevel: 'H',
          }"
          :imageOptions="{
            hideBackgroundDots: true,
            imageSize: 0.4,
            margin: 0,
          }"
          :dotsOptions="{
            type: 'square',
            color: '#000000',
            gradient: null,
          }"
          image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAABU2lDQ1BpY20AABiVY2BgPJGTnFvMJMDAkJtXUhTk7qQQERmlwP6IgZlBhIGTgY9BNjG5uMA32C2EgYGBoTixvDi5pCiHAQV8u8bACKIv62Yk5qXMnchg69CwwdahRKdx3lKlPgb8gDMltTiZgYHhAwMDQ3xyQVEJAwMjDwMDA095SQGILcHAwCBSFBEZxcDAqANip0PYDiB2EoQdAlYTEuTMwMCYwcDAkJCOxE5CYkPtAgHW0iB3J2SHlKRWlIBoZ2cDBlAYQEQ/h4D9xih2EiGWv4CBweITAwNzP0IsaRoDw/ZOBgaJWwgxlQUMDPytDAzbjiSXFpVBrdFiYGCoYfjBOIeplLmZ5SSbH4cQlwRPEt8XwfMi3ySyZPQUnFXWaGbp1Rm/ttxsf80t3NcspCxGPEU2p600rK63Q2eS2ZzVy3s23d4389Tx66lPyj/+/P8fAEeDZOWRl0f5AAAAt1BMVEX///+9m2sBZT+6l2Hdz7rg0r28nW6+mmm7lWTm380AWi3//v28m2wAYjr6+fTx7eDQuZr1+/pll4SivbMAVyYAWjIPakXNtJTB1s4AWStKgWoAZz8AXTLZ5OAAYjcAXznM3ddAf2JXjHcAXS40d1sdbU7e7unt9/Onxr1hk3sAWSUASwV4oJNMhW/KsYzw/PvW6uS51MyVtqqGrp97qpgATBQqcVW4j1ri6uewyMI5eWEsdlUXaUqAUKyBAAAF2ElEQVR4nO3df1vaSBDA8WSohxcar5HAETcmIihKtYhWz1/v/3XdgwoFBLLZnZ3Z3s33j/sz8OmqfeocO0EgSZIkSZIkSZIkkXbB/QZcd3iK96zRId6z0LocI76r5PsV3sNQagWneYwpTAe+neJpDrhC5RnxOoeFsGXTx/OSFGCA+H1tW3KUAyCfIYDKvSEm/RlwIfzbph9/vj8ynT0xv+aFzZsMC1gWhvth07j9ZSHk/YTX9tZkWMKK8I/m19C4VSEUz/zE0UMM7oRQDCe8vmByNge6EarimZd4/roAuhECFGcjT4CuhIqTeA5LQFdCgKLLRbxZAboTQtE95wGWK0CHQoiBg3i8BnQphKI8Jgfe5ArohAAxNfGks/4WHAtVTkvcAHQrVFAMTgiBvegz0PEZAqiMjjjtrH8PUghBDXpUwE0nSCAElU5JgBfZRiCBEGBMQdwGJBGq9IkPSCIESF3/Zr29FUgkVI6Jt5t/yBAKAdK2S+D2E6QTwvjWGfBuxwkSCiG9YwESCiFzQ7za9SVKK4Tspwvg7hOkFbogHlYBaYUqwh5NHeZVQFohADJRA0gtVINLROCpBpBaCIA4fdMC0gvRpm/v808fhUjE5KjQejUOIcqAMelrAlmEkFsPGJOhLpBHCLHlgDF50AYyCaF8sCFOzvSBXEKIX8xHU6OzGDb93tAvocUMdfRa4wQZhRC/mo2mVga8XgsNp2/nca0TZBUaEdcGvJ4LAcqbusAy1v8Z44MwrjlDvSlrfomyCwFK/dFUa+N40HshdPSJJxunZ94LIdebvrWCnhHQAyF09Ii91AjogxAinenbNFK/rxCyauLU5ATVrMIHIWRVo6mL+8Eg2lW2tfQUUTiOTauYviVPveVOPne8vUc84eSh3+/3j+p2PfvP0Pn/z4Ah9DsRitD/ROiB8OCLTXvmvDD82vi2Z/Pimn8+f/3TsMlGGDatXrrxQ1PYCJvmb9EKGIYWX+Fh2PimKdy3ehnGmtpC7ndqmghF6H8iFKH/iVCE/idCEfqfCEXofyIUof+JUIT+J0IR+p8IReh/IhSh/4lQhP4nQhH6nwhF6H8iFKH/iVCE/idCEfqfCEXofyIUof/pC//zn7dg/cxM0+bFdYWcn3vap/jc08GXPZtsTnH22TWLdD+7Ztlv8PlDy0QoQv8TIbNwlJg3QRQ+9syb7rwO8+m+Y1yZ4Anb9ztvWNnV94rrzHvpx3Uz9esinmFb797bDVflZJW37vc+LXLSzQehiio3J7SCXmZI9ECodFZDtAwvM/NCWHmH0keGRHah0gUa3ZrogVBpXPT1iwgGRGah0rqsbdF57cs92YVRzRuw6t5AyyxUSvNGwaVq3iLMLYwM1s6NatzlzSxUqvYVtG/Vus2bVVh0jIBBMBoWdX6isgkVGAJr3arPJ1Sxstg0mzwX+rey8whV3H00B9bYbsEmLG3XIetuKOESYmzt1tsywyQsHjB2dusSGYTFi93+jnk6255YhIX1DpZ6RHJhMcQCaqyV4xDG13hAPSKxEGuf1by7iu2H5ELEnWRzYuUpkgrxgRqnSCnMsdcfvnVb8YtUQqEbYMWyXEoh+gLLRdtXVpMKoytXwAoilTBysUhWi0gkdLQMeNF0+18aNMLI3c7qOXHrKVIINcaD9vW2/fFSCDOXi9UXnWz5QiUQ6g+XLImb10G5F1IBZ8RNQw3nQjrgbMDIIOzUmp7Zdlx+PkXHQlrgxgGjW2H96Zk1sbtOdCrU3KmGS1yfoboU5gbjQftGa9M3d0JVc32jK6IzYWw2/0QhvhQUQj7gbMCYOxearcJFazKMHQuZgbPt8rlToem+ZsyOBg6FMcJ40L759M2B0GZvOmYfRHxhOfQDGASXAyfC4hln/onRZbQiNG9ZmPcxp2e2HQ4WwrDRNK/xS+gXMAiusrnwwKrW+0PaOfZ40L6f4y7i09pj74BBcJcjPuzWwXjQvlvE7xuWfw5KkiRJkiRJkiT9n/sX5Z9BlJTdWfcAAAAASUVORK5CYII="
          :backgroundOptions="{ color: '#ffffff' }"
          :cornersSquareOptions="{ type: 'dot', color: '#000000' }"
          :cornersDotOptions="{ type: undefined, color: '#000000' }"
          fileExt="png"
          myclass="my-qur"
          imgclass="img-qr"
        />
      </div>
      <div class="fs-18 fw-500 fc-696969 center">{{ $t("scan") }}</div>
      <div v-if="canShare" class="flex-center mt-36" style="margin: 10px">
        <a
          :href="qr_codeLink"
          download="appointment.png"
          @click="downloadQrcode"
          class="big-btn flex-mid ml-auto mr-18"
          style="background-color: #206b5e"
        >
          <!-- <div
          class="big-btn flex-mid ml-auto mr-18"
          
        > -->
          <div class="center">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.665 7.97625L17.0237 1.335C16.2509 0.561191 15.2024 0.125963 14.1088 0.125H4.25C3.15598 0.125 2.10677 0.559597 1.33318 1.33318C0.559597 2.10677 0.125 3.15598 0.125 4.25V20.75C0.125 21.844 0.559597 22.8932 1.33318 23.6668C2.10677 24.4404 3.15598 24.875 4.25 24.875H20.75C21.844 24.875 22.8932 24.4404 23.6668 23.6668C24.4404 22.8932 24.875 21.844 24.875 20.75V10.8912C24.874 9.7976 24.4388 8.7491 23.665 7.97625V7.97625ZM9.75 22.125V19.375H15.25V22.125H9.75ZM22.125 20.75C22.125 21.1147 21.9801 21.4644 21.7223 21.7223C21.4644 21.9801 21.1147 22.125 20.75 22.125H18V18C18 17.6353 17.8551 17.2856 17.5973 17.0277C17.3394 16.7699 16.9897 16.625 16.625 16.625H8.375C8.01033 16.625 7.66059 16.7699 7.40273 17.0277C7.14487 17.2856 7 17.6353 7 18V22.125H4.25C3.88533 22.125 3.53559 21.9801 3.27773 21.7223C3.01987 21.4644 2.875 21.1147 2.875 20.75V4.25C2.875 3.88533 3.01987 3.53559 3.27773 3.27773C3.53559 3.01987 3.88533 2.875 4.25 2.875H7V9.75C7 10.1147 7.14487 10.4644 7.40273 10.7223C7.66059 10.9801 8.01033 11.125 8.375 11.125H13.875C14.2397 11.125 14.5894 10.9801 14.8473 10.7223C15.1051 10.4644 15.25 10.1147 15.25 9.75C15.25 9.38533 15.1051 9.03559 14.8473 8.77773C14.5894 8.51987 14.2397 8.375 13.875 8.375H9.75V2.875H14.1088C14.4728 2.88006 14.8215 3.02249 15.085 3.27375L21.7262 9.915C21.8537 10.0435 21.9545 10.1959 22.0229 10.3634C22.0914 10.5309 22.126 10.7103 22.125 10.8912V20.75Z"
                fill="white"
              />
            </svg>
            <div class="mt-6">{{ $t("save") }}</div>
          </div>
          <!-- </div> -->
        </a>
        <div
          @click="shareQrcode"
          class="big-btn flex-mid mr-auto"
          style="background-color: #c8c8b9"
        >
          <div class="center">
            <svg
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.7504 18.125C20.8011 18.1258 19.89 18.4989 19.2129 19.1642L9.66705 14.9108V14.5V14.1013L19.2129 9.83585C19.8108 10.4219 20.5931 10.7829 21.427 10.8576C22.2609 10.9323 23.095 10.716 23.7875 10.2455C24.48 9.77506 24.9883 9.07936 25.2261 8.2766C25.4639 7.47384 25.4165 6.61352 25.0919 5.84177C24.7673 5.07001 24.1856 4.43439 23.4456 4.04287C22.7055 3.65134 21.8528 3.52806 21.0321 3.69394C20.2115 3.85983 19.4736 4.30466 18.9437 4.95289C18.4139 5.60112 18.1247 6.41278 18.1254 7.25001V7.66085L8.57955 11.9142C8.07007 11.4136 7.42408 11.0747 6.72266 10.9401C6.02125 10.8054 5.29568 10.8809 4.63704 11.1571C3.97839 11.4334 3.41603 11.898 3.02054 12.4927C2.62505 13.0875 2.41406 13.7858 2.41406 14.5C2.41406 15.2142 2.62505 15.9125 3.02054 16.5073C3.41603 17.102 3.97839 17.5667 4.63704 17.8429C5.29568 18.1191 6.02125 18.1947 6.72266 18.06C7.42408 17.9253 8.07007 17.5864 8.57955 17.0858L18.1254 21.3513V21.75C18.1254 22.467 18.338 23.1678 18.7363 23.764C19.1346 24.3601 19.7008 24.8247 20.3632 25.0991C21.0255 25.3734 21.7544 25.4452 22.4576 25.3054C23.1608 25.1655 23.8067 24.8202 24.3136 24.3133C24.8206 23.8063 25.1659 23.1604 25.3057 22.4572C25.4456 21.754 25.3738 21.0252 25.0994 20.3628C24.8251 19.7004 24.3605 19.1343 23.7643 18.7359C23.1682 18.3376 22.4673 18.125 21.7504 18.125ZM21.7504 6.04168C21.9894 6.04168 22.223 6.11255 22.4217 6.24532C22.6204 6.37809 22.7753 6.56681 22.8667 6.7876C22.9582 7.0084 22.9821 7.25135 22.9355 7.48575C22.8889 7.72014 22.7738 7.93544 22.6048 8.10443C22.4358 8.27342 22.2205 8.3885 21.9861 8.43513C21.7517 8.48175 21.5088 8.45782 21.288 8.36637C21.0672 8.27491 20.8785 8.12003 20.7457 7.92133C20.6129 7.72262 20.5421 7.489 20.5421 7.25001C20.5421 6.92954 20.6694 6.6222 20.896 6.39559C21.1226 6.16898 21.4299 6.04168 21.7504 6.04168ZM6.04205 15.7083C5.80307 15.7083 5.56945 15.6375 5.37074 15.5047C5.17203 15.3719 5.01715 15.1832 4.9257 14.9624C4.83424 14.7416 4.81031 14.4987 4.85694 14.2643C4.90356 14.0299 5.01864 13.8146 5.18763 13.6456C5.35662 13.4766 5.57192 13.3615 5.80632 13.3149C6.04071 13.2683 6.28367 13.2922 6.50446 13.3837C6.72526 13.4751 6.91397 13.63 7.04674 13.8287C7.17952 14.0274 7.25039 14.261 7.25039 14.5C7.25039 14.8205 7.12308 15.1278 6.89647 15.3544C6.66987 15.581 6.36252 15.7083 6.04205 15.7083ZM21.7504 22.9583C21.5114 22.9583 21.2778 22.8875 21.0791 22.7547C20.8804 22.6219 20.7255 22.4332 20.634 22.2124C20.5426 21.9916 20.5186 21.7487 20.5653 21.5143C20.6119 21.2799 20.727 21.0646 20.896 20.8956C21.065 20.7266 21.2803 20.6115 21.5147 20.5649C21.749 20.5183 21.992 20.5422 22.2128 20.6337C22.4336 20.7251 22.6223 20.88 22.7551 21.0787C22.8879 21.2774 22.9587 21.511 22.9587 21.75C22.9587 22.0705 22.8314 22.3778 22.6048 22.6044C22.3782 22.831 22.0709 22.9583 21.7504 22.9583Z"
                fill="white"
              />
            </svg>

            <div class="mt-6">{{ $t("share") }}</div>
          </div>
        </div>
      </div>

      <a
        v-else
        :href="qr_codeLink"
        download="appointment.png"
        @click="downloadQrcode"
        class="btn-48 btn-primary btn mx-auto mt-22"
        style="max-width: 20rem; color: white"
      >
        <svg
          width="23"
          height="23"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.665 7.97625L17.0237 1.335C16.2509 0.561191 15.2024 0.125963 14.1088 0.125H4.25C3.15598 0.125 2.10677 0.559597 1.33318 1.33318C0.559597 2.10677 0.125 3.15598 0.125 4.25V20.75C0.125 21.844 0.559597 22.8932 1.33318 23.6668C2.10677 24.4404 3.15598 24.875 4.25 24.875H20.75C21.844 24.875 22.8932 24.4404 23.6668 23.6668C24.4404 22.8932 24.875 21.844 24.875 20.75V10.8912C24.874 9.7976 24.4388 8.7491 23.665 7.97625V7.97625ZM9.75 22.125V19.375H15.25V22.125H9.75ZM22.125 20.75C22.125 21.1147 21.9801 21.4644 21.7223 21.7223C21.4644 21.9801 21.1147 22.125 20.75 22.125H18V18C18 17.6353 17.8551 17.2856 17.5973 17.0277C17.3394 16.7699 16.9897 16.625 16.625 16.625H8.375C8.01033 16.625 7.66059 16.7699 7.40273 17.0277C7.14487 17.2856 7 17.6353 7 18V22.125H4.25C3.88533 22.125 3.53559 21.9801 3.27773 21.7223C3.01987 21.4644 2.875 21.1147 2.875 20.75V4.25C2.875 3.88533 3.01987 3.53559 3.27773 3.27773C3.53559 3.01987 3.88533 2.875 4.25 2.875H7V9.75C7 10.1147 7.14487 10.4644 7.40273 10.7223C7.66059 10.9801 8.01033 11.125 8.375 11.125H13.875C14.2397 11.125 14.5894 10.9801 14.8473 10.7223C15.1051 10.4644 15.25 10.1147 15.25 9.75C15.25 9.38533 15.1051 9.03559 14.8473 8.77773C14.5894 8.51987 14.2397 8.375 13.875 8.375H9.75V2.875H14.1088C14.4728 2.88006 14.8215 3.02249 15.085 3.27375L21.7262 9.915C21.8537 10.0435 21.9545 10.1959 22.0229 10.3634C22.0914 10.5309 22.126 10.7103 22.125 10.8912V20.75Z"
            fill="white"
          />
        </svg>

        <div class="ml-10">{{ $t("save") }}</div>
      </a>
      <p class="center pl-10 pr-10 pt-2" style="color: red">{{ errShare }}</p>
    </div>
    <div
      class="link center"
      @click="
        $router.push({ path: '/package-details', query: { orderId: orderId } })
      "
    >
      {{ $t("packageDetail") }}
    </div>
  </div>
  <p class="result"></p>
  <div style="background-color: #f3f3e7">
    <div class="body-max-width-no-padding">
      <div class="tutorial-card">
        <div class="tutorial-text">{{ $t("tutorial") }}</div>
        <div
          class="step"
          v-for="(value, index) in tutorial"
          :key="index + '_des'"
        >
          <div class="number flex-mid">{{ index }}</div>
          <div class="label">{{ value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import QRCodeVue3 from "qrcode-vue3";

export default defineComponent({
  name: "QRCode",
  components: {
    Header,
    QRCodeVue3,
  },
  data() {
    return {
      orderId: null,
      errShare: null,
      qr_codeLink: null,
      canShare: false,
      tutorial: [
        "Press the Windows key on the keyboard, or click Start. The Start menu",
        "In the Start menu, click the Power icon, then click Shut down.",
        "Press Ctrl+Alt+Del and click the power button in the bottom-right corner of the screen.",
        "From the Windows desktop, press Alt+F4 to get the Shut Down Windows screen shown here.",
        "Wait a few secon then plug out!",
      ],
    };
  },
  computed: {
    url() {
      return window.location.href;
    },
    title() {
      return document.title;
    },
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
    this.downloadQrcode();
    this.canShare = navigator.canShare;
    // this.canShare = true;
  },
  methods: {
    downloadQrcode() {
      const downloadQrcode = window.$(".img-qr").attr("src");
      this.qr_codeLink = downloadQrcode;
    },
    shareQrcode() {
      this.errShare = null;
      this.downloadQrcode();
      // console.log(this.qr_codeLink);
      const url = this.qr_codeLink;
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const testFile = new File([blob], "appointment.png", {
            type: "image/png",
          });
          console.log(blob);
          console.log(testFile);
          let data = {
            files: [testFile],
            text: "AppointmenQr",
            title: "AppointmenQr",
          };
          if (navigator.canShare && navigator.canShare(data)) {
            navigator
              .share(data)
              .then(() => {
                console.log("Share was successful.");
              })
              .catch((error) => {
                // this.errShare = "Sharing failed" + error;
                window.location.reload(true);
              });
          } else {
            this.errShare = `Your system doesn't support sharing files.`;
            console.log(`Your system doesn't support sharing files.`);
          }
        });
    },
    onError(err) {
      alert(err);
      console.log(err);
    },
    onSuccess(err) {
      console.log(err);
    },
  },
});
</script>

<style lang="scss" scoped>
a:link {
  text-decoration: none;
  color: #fff;
}

a:visited {
  text-decoration: none;
  color: #fff;
}

a:hover {
  text-decoration: none;
  color: #fff;
}

a:active {
  text-decoration: none;
  color: #fff;
}

.img-qr {
  background: red;
}
.code-card {
  width: calc(100%);
  padding: 0 0 2.6rem;
  max-width: 39rem;
  border-radius: 3rem;
  margin: 3rem auto 0;
  background: #ffffff;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
}
.big-btn {
  width: 10rem;
  height: 10rem;
  border-radius: 10rem;
  transition: 0.3s;
  cursor: pointer;
  color: #fff;
  font-size: 1.8rem;
  font-weight: 500;
}
.link {
  font-weight: 800;
  font-size: 14px;
  text-decoration-line: underline;
  cursor: pointer;
  color: #206b5e;
  margin-top: 2rem;
}
.tutorial-card {
  margin-top: 2rem;
  padding: 3rem 4rem;
  background-color: #f3f3e7;
  .tutorial-text {
    font-weight: 500;
    font-size: 1.8rem;
    color: #131313;
    margin-bottom: 3.7rem;
  }
  .step {
    display: grid;
    grid-template-columns: 4.8rem auto;
    margin: 0 0 2.6rem;
    .number {
      width: 3rem;
      padding-top: 0.1rem;
      height: 2.9rem;
      border-radius: 3rem;
      background: #b0b0b0;
      font-weight: 600;
      font-size: 1.6rem;
      color: #ffffff;
    }
    .label {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      color: #b0b0b0;
      padding-top: 0.7rem;
    }
  }
}
</style>
